<template>
  <div class="header-table">
    <!-- Кабинеты -->
    <div class="cabinet-row" :style="rowStyle">
      <template v-for="roomEntry in roomsWithEmployees" :key="roomEntry.room.id">
        <div
          class="cabinet-cell"
          :style="{
            gridColumn: `span ${roomEntry.employees.length}`,
            width: empColWidth * roomEntry.employees.length + 'px'
          }"
        >
          {{ roomEntry.room.name }}
        </div>
      </template>
      <!-- Фейковый столбец справа для скролла -->
      <div v-if="scrollbarWidth" class="header-scroll-fake-scrollbar" :style="{ width: scrollbarWidth + 'px' }"></div>
    </div>
    <!-- Сотрудники -->
    <div class="employee-row" :style="rowStyle">
      <template v-for="roomEntry in roomsWithEmployees" :key="roomEntry.room.id">
        <template v-for="emp in roomEntry.employees" :key="emp.user_id">
          <div class="employee-cell" :style="{ width: empColWidth + 'px' }">
            <EmployeeAvatar :name="emp.user_name" :avatar-url="emp.avatar" />
            <span class="employee-name" :title="emp.user_name">{{ emp.user_name }}</span>
          </div>
        </template>
      </template>
      <!-- тот же фейковый столбец -->
      <div v-if="scrollbarWidth" class="header-scroll-fake-scrollbar" :style="{ width: scrollbarWidth + 'px' }"></div>
    </div>
  </div>
</template>

<script>
import EmployeeAvatar from '@/components/util/calendar/EmployeeAvatar.vue'

export default {
  name: "HeaderCabinetsAndEmployees",
  components: { EmployeeAvatar },
  props: {
    roomsWithEmployees: Array,
    empColWidth: { type: Number, default: 200 },
    scrollbarWidth: { type: Number, default: 16 }, // <--- принимаем ширину скролла как пропс
  },
  computed: {
    totalEmpCount() {
      return this.roomsWithEmployees.reduce((sum, r) => sum + r.employees.length, 0)
    },
    rowStyle() {
      // +1 столбец справа если нужен "фейк"
      const colCount = this.totalEmpCount + (this.scrollbarWidth ? 1 : 0)
      return {
        display: 'grid',
        gridTemplateColumns: `repeat(${colCount}, ${this.empColWidth}px)`
      }
    }
  }
}
</script>

<style scoped>
.header-scroll-fake-scrollbar {
  background: transparent;
  pointer-events: none;
  height: 100%;
}
.header-table {
  background: #fff;
  user-select: none;
}
.cabinet-row, .employee-row {
  width: 100%;
}
.cabinet-cell {
  background: #ecfaff;
  font-weight: 600;
  border-right: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 52px;
  box-sizing: border-box;
}
.employee-cell {
  border-right: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  box-sizing: border-box;
  background: #fff;
}
.employee-cell:last-child {
  border-right: none;
}
.employee-name {
  font-size: 14px;
  margin-left: 10px;
  white-space: nowrap;          /* не переносить */
  overflow: hidden;             /* скрывать лишнее */
  text-overflow: ellipsis;      /* ... в конце */
  max-width: 120px;             /* подобрать подходящий размер */
  display: block;
  cursor: pointer;
}
</style>